import { createContext, useContext } from 'react';

/**
 * Which palette the surrounding tool uses. Light panels are the default; the
 * panorama editor roots a `.dark` class that redefines the color tokens.
 *
 * Radix portals (dialogs, menus, popovers, selects, tooltips) render under
 * <body>, OUTSIDE that `.dark` root, so they would come out light on top of a
 * dark editor. Portaled kit components therefore read this context and add the
 * `dark` class to themselves.
 */
export type Surface = 'light' | 'dark';

export const SurfaceContext = createContext<Surface>('light');

export function useSurface(): Surface {
  return useContext(SurfaceContext);
}

/** Class a portaled element needs so the tokens resolve for its surface. */
export function surfaceClassName(surface: Surface): string {
  return surface === 'dark' ? 'dark' : '';
}
